import { type FC } from 'react'

import { Box } from '@mantine/core'

const RightSectionHelper: FC = () => {
  return (
    <Box
      bg='var(--mantine-color-item-bg-selected)'
      c='var(--mantine-color-text-dimmed)'
      h='calc(100% - 4px)'
      fz='xs'
      mr={2}
      py={4}
      px={12}
      style={{ borderRadius: 4 }}
    >
      .shalion.com
    </Box>
  )
}

export default RightSectionHelper
